import type { ValidateStatus } from 'antd/es/form/FormItem';

export const VALIDATION_STATUS: Readonly<{ [K in ValidateStatus as Capitalize<K>]: K }> = {
  Success: 'success',
  Error: 'error',
  Warning: 'warning',
  Validating: 'validating',
  '': '',
} as const;
